import { colors } from "./colors.ts";

export const semanticTokens = {
  colors,
};
